import { FormikErrors } from 'formik'
import { ChangeEvent } from 'react'
import { FormOptionModal } from 'src/app/modules/common/Model'
import FormSelect from 'src/cms/helpers/components/forms/FormSelect'
import * as Yup from 'yup'

interface Props {
  handleChange: (e: ChangeEvent<any>) => void
  errors: FormikErrors<{ [key: string]: string }> | any
  touched: any
  programOptionOptions: FormOptionModal[]
  programDataOption?: FormOptionModal[]
  validationState: { [key: string]: Yup.StringSchema }
  setValidationState: any
  values: any
  setFieldValue: any
}

export function RelatedProgramComponent({
  handleChange,
  errors,
  touched,
  values,
  programDataOption,
  programOptionOptions,
  validationState,
  setValidationState,
  setFieldValue,
}: Props) {
  const showRelatedId = programOptionOptions?.find(
    (item: FormOptionModal) => item.value === values.related_option_id
  )
  // useEffect(() => {
  //   showRelatedId?.systemName === 'yes'
  //     ? setValidationState({
  //         ...validationState,
  //         programSection: Yup.string().required('Download  Data is required'),
  //       })
  //     : showRelatedId?.systemName === 'no'
  //     ? setValidationState({
  //         ...validationState,
  //         programSection: Yup.string().nullable(),
  //       })
  //     : null
  // }, [values.programSection])

  return (
    <>
      <div className=''>
        <div className='row'>
          <div className='col-md-6 col-xs-12'>
            <FormSelect
              labelClassName='col-md-12'
              containerClassName='col-md-12'
              placeholder='Please select'
              label='Show program'
              name='related_option_id'
              onChange={handleChange}
              errors={errors}
              touched={touched}
              options={programOptionOptions}
              required
              values={values}
              setFieldValue={setFieldValue}
            />
          </div>
          {showRelatedId?.systemName === 'yes' ? (
            <>
              <div className='col-md-6 col-xs-12'>
                <FormSelect
                  labelClassName='col-md-12'
                  containerClassName='col-md-12'
                  placeholder='Please select'
                  label='Program Options'
                  name='relatedProgramData'
                  onChange={handleChange}
                  errors={errors}
                  touched={touched}
                  options={programDataOption}
                  values={values}
                  setFieldValue={setFieldValue}
                  multiple={true}
                />
              </div>
            </>
          ) : null}
        </div>
      </div>
    </>
  )
}
